import React from 'react';
import { Link } from 'react-router';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import { CheckBoxField, DEFAULT_REQUIRED_MESSAGE } from 'common/components/form_fields';

const ReviewForm = ({error, handleSubmit, submitting, submitFailed}) => (
  <section className="review-item review-form">
    <form onSubmit={handleSubmit}>

      <fieldset>
        <h4>Stay Up-to-Date</h4>

        <Field name="receive_communication" component={CheckBoxField}
          label="Crowdspring can communicate with me from time to time about design and naming trends and other useful information."/>

        <h4>Play By the Rules</h4>

        <Field name="accepted_terms_of_use" component={CheckBoxField}
          label={<span>
            I agree to the <Link to="/standards-of-conduct-creative/" target="_blank">Standards of Conduct</Link> and <Link to="/user-agreement/" target="_blank">User Agreement</Link>.
          </span>}
        />
      </fieldset>

      <AnimatedButton processing={submitting} type="submit" label="Finish"
        baseBtnClass="btn-tertiary btn-block" processingLabel="Finishing..."
        errorMsg={error || submitFailed} successMsg="Done!"/>
    </form>
  </section>
)

const validate = values => {
  const errors = {}
  if (!values.accepted_terms_of_use) {
    errors.accepted_terms_of_use = 'You must agree to our policies before proceeding'
  }
  return errors
}

export default reduxForm({
  form: "ReviewForm",
  validate,
})(ReviewForm);



// WEBPACK FOOTER //
// ./registration/creative/components/review_form.jsx